import React from 'react';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

export const EmptyState = () => {
  const {messages} = useIntl();
  return (
    <Box
      sx={{
        width: "280px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        padding: '40px 20px',
        textAlign: 'center',
      }}
    >
      <Typography 
        variant="body1" 
        sx={{
          color: '#666',
          fontSize: '14px',
          lineHeight: 1.5,
        }}
      >
        {messages['realtimemaps_vehicletrails_empty_state']}
      </Typography>
    </Box>
  );
};
